export default "__VITE_ASSET__29P5wbp$__"